"use client";

import { useEffect, useState } from "react";

// Site is statically exported, so this is checked in the browser, not at build time —
// the banner disappears on its own after the cutoff with no redeploy needed.
const BANNER_EXPIRES = new Date("2026-10-21T00:00:00-04:00");

export default function HolidayBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(new Date() < BANNER_EXPIRES);
  }, []);

  if (!visible) return null;

  return (
    <div role="status" className="bg-emerald-800 text-white">
      <div className="container mx-auto px-4 py-2.5 text-center text-sm leading-snug">
        <span className="font-semibold">Shipping Notice:</span> Tropical
        Storm Isaias may delay deliveries to Louisiana, Mississippi,
        Alabama, Georgia, and Florida. Orders are still being processed
        and shipped as normal &mdash; thank you for your patience.
      </div>
    </div>
  );
}
